import { selectors } from 'client/reducers/managementReducer'
import { shallowEqual, useSelector } from 'react-redux'

export default function useManagement(selector) {
  return useSelector(state => selector(state.management), shallowEqual)
}

export { selectors }
